import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import es from "date-fns/locale/es";
import dayjs from "dayjs";
import { useState } from "react";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

type EnvioProgramadoProps = {
    onChange: (envioProgramado: any) => void;
    value?: Date;
}

const parsedDate = (envioSeleccionado: number | Date) => {

    const isDate = typeof envioSeleccionado === 'object';
    if (isDate) {
        return dayjs(envioSeleccionado as Date).toDate().toISOString();
    }


    switch (envioSeleccionado) {
        case 0:
            return undefined
        case 1:
            return dayjs().toDate().toISOString()
        case 10:
            return dayjs().add(10, 'minutes').toDate().toISOString()
        case 20:
            return dayjs().add(20, 'minutes').toDate().toISOString()
        case 30:
            return dayjs().add(30, 'minutes').toDate().toISOString()
        case 60:
            return dayjs().add(1, 'hour').toDate().toISOString()
        case 120:
            return dayjs().add(2, 'hour').toDate().toISOString()
        default:
            return undefined
    }
}




const EnvioProgramado = ({ onChange, value }: EnvioProgramadoProps) => {

    const [envioProgramado, setEnvioProgramado] = useState<string | number | undefined>(1);

    const handleOnChangeSelect = (envioProgramado?: string | number) => {
        setEnvioProgramado(envioProgramado);
        if (envioProgramado === "custom") {
            const date = dayjs().add(1, 'minutes').toDate().toISOString();
            return onChange(date);
        }
        Number.isInteger(envioProgramado) && onChange(parsedDate(envioProgramado as number));
    }

    return (<Box display='flex' flexDirection='column'>
        <FormControl size="small" sx={{ width: '13rem' }}>
            <InputLabel size="small" id="envio-programado-label">Envío programado</InputLabel>
            <Select
                labelId="envio-programado-label"
                id="envio-programado"
                value={envioProgramado}
                label="Envío programado"
                onChange={(e) => handleOnChangeSelect(e.target.value)}
            >
                <MenuItem value={0}>No mandar</MenuItem>
                <MenuItem value={1}>Enviar ahora</MenuItem>
                <MenuItem value={10}>10 minutos</MenuItem>
                <MenuItem value={20}>20 minutos</MenuItem>
                <MenuItem value={30}>30 minutos</MenuItem>
                <MenuItem value={60}>1 hora</MenuItem>
                <MenuItem value={120}>2 horas</MenuItem>
                <MenuItem value="custom">Envio programado</MenuItem>
            </Select>
        </FormControl>
        {envioProgramado === "custom" && (
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                <DateTimePicker label="Selección libre"
                    sx={{ width: '13rem', my: 2 }}
                    value={value ?? null}
                    onChange={(date: any) => {
                        const d = date.toISOString()
                        onChange(d);
                    }}
                    slotProps={{ textField: { placeholder: 'Seleccionar fecha y hora', size: 'small' } }}
                />
            </LocalizationProvider>
        )}
    </Box>);
}


export default EnvioProgramado;